import { useLang } from '@/i18n';
import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import EfSwiperOnlyH5 from '@elem/ui/ef-swiper-only-h5';
import { useRouter } from 'next/router';
import styles from './index.module.scss';
// import EFXBoost from 'elem/ui-assets/icons/unregular/EFXBoost';

export default function TheComp() {
    const { t } = useLang('theProduct.SectionF');
    const { locale = 'us' } = useRouter();
    const IS_EU_SITES = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'kr', 'ph', 'nl'].includes(locale);
    const NAImg = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724651727536/smaller%20than%20the%20industry%20average.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724651727179/smaller%20than%20the%20industry%20average%20(1).jpg',
    };
    const EUImg = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725436367090/eu_pc.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725436366907/eu_m.jpg',
    };
    const UKImg = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725436366618/uk_pc.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725436366259/uk_m.jpg',
    };
    const PHImg = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1751090482327/I1.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1751090532824/I1-m.jpg',
    };

    const imgLocale: any = {
        us: NAImg,
        ca: NAImg,
        br: NAImg,
        mx: NAImg,
        uk: UKImg,
        eu: EUImg,
        de: EUImg,
        fr: EUImg,
        it: EUImg,
        es: EUImg,
        nl: EUImg,
        ph: PHImg,
    };
    const imgA = imgLocale[locale] || imgLocale['eu'];
    const items = [
        {
            pc: imgA.pc,
            h5: imgA.h5,
            section: (
                <>
                    <div className="title">{t('a_title')}</div>
                    <div className="text">{t('a_desc')}</div>
                </>
            ),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724997808301/aa1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724997824740/aa2.jpg',
            section: IS_EU_SITES ? (
                <>
                    <div className="title">{t('b_title')}</div>
                </>
            ) : (
                <></>
            ),
        },
    ];

    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-x" />
            <EfSection label={IS_EU_SITES ? t('label') : ''} hasAnimation={false} title={t('title')} desc={t('desc')} />
            <EfSwiperOnlyH5 items={items} loop={true} />
        </div>
    );
}
